import { useQuery } from '@tanstack/react-query';
import { API } from '../api';
import { queryKeys } from './queryKeys';
import { useAppSelector } from '../redux/hooks';
import useProfileDetails from '../hooks/useProfileDetails';
import { getUserDetails } from '../utils/orgName';
// import { QueryKey } from "@tanstack/react-query";

const useUpcominMeeting = (orgId: string) => {
  const { location } = getUserDetails();

  return useQuery({
    queryKey: [queryKeys.GET_UPCOMING_MEETING, orgId],
    queryFn: () => {
      return API.getUpcomingMeeting(orgId, location);
    },
    staleTime: 10 * 10 * 1000,
    enabled: false
  });
};
export default useUpcominMeeting;
